import { Sparkles, Layers, Gift } from "lucide-react";

const ITEMS = [
  {
    Icon: Sparkles,
    title: "Statement-Made",
    sub: "Not for blending in. Made to be remembered.",
  },
  {
    Icon: Layers,
    title: "Assorted Pieces",
    sub: "Made in small lots. Loved, cherished and remembered.",
  },
  {
    Icon: Gift,
    title: "The Edge Box",
    sub: "Unbox her power. No wrapping needed.",
  },
];

export default function ValueProps() {
  return (
    <section
      data-testid="value-props"
      className="w-full bg-[#0A0A0A]"
      style={{ borderTop: "1px solid #F5D565" }}
    >
      <div
        className="max-w-[1500px] mx-auto grid grid-cols-1 md:grid-cols-3 items-start"
        style={{ paddingTop: 56, paddingBottom: 56, paddingLeft: 24, paddingRight: 24, columnGap: 32, rowGap: 32 }}
      >
        {ITEMS.map(({ Icon, title, sub }) => (
          <div
            key={title}
            data-testid={`vp-${title.replace(/\s+/g, "-").toLowerCase()}`}
            className="flex flex-col items-center text-center"
          >
            <Icon size={28} strokeWidth={1.5} style={{ color: "#F5D565" }} />
            <span
              className="font-ui mt-4"
              style={{
                fontSize: 14,
                letterSpacing: "1.5px",
                color: "#F5D565",
                fontWeight: 600,
                textTransform: "uppercase",
                lineHeight: 1.2,
              }}
            >
              {title}
            </span>
            <span
              className="font-body mt-2"
              style={{
                fontSize: 14,
                color: "rgba(255,255,255,0.72)",
                lineHeight: 1.55,
                maxWidth: 280,
              }}
            >
              {sub}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
